import request from '@/utils/request';

const PATH = '/industry';

export const getIndustryListAll = () => request({
  url: PATH,
  method: 'get',
});
